import { ColumnItem } from '@model/column-item.model';
import { sortDate, sortNullableString } from '@shared/util/table.utils';
import { DashboardMonitoringSheetColumnKeys } from '../enums/dashboard-monitoring-sheet-index-column-keys';
import { MonitoringSheetIndexDashboardDto } from '@model/monitoring-sheet/monitoring-sheet-index-dashboard-dto';


export const MonitoringSheetIndexDashboardColumns: ColumnItem<MonitoringSheetIndexDashboardDto>[] = [
    {
        name: 'dashboard.table.controlPoints',
        value: DashboardMonitoringSheetColumnKeys.DECISION_PERIMETER,
        sortOrder: null,
        sortFn: (a: MonitoringSheetIndexDashboardDto, b: MonitoringSheetIndexDashboardDto) => {
            const spjOrder = sortNullableString(a.spj, b.spj);
            return spjOrder !== 0 ? spjOrder : sortNullableString(a.title, b.title);
        },
        sortDirections: ['ascend', 'descend', null],
        listOfFilter: [],
        filterFn: (selected: string[], item) => selected.includes(item.decisionPerimeterGuid),
        filterMultiple: false,
        type: 'string',
        searchFilter: false,
        defaultFilter: false,
        treeFilter: true
    },
    {
        name: 'dashboard.table.frequency',
        value: DashboardMonitoringSheetColumnKeys.FREQUENCY,
        sortOrder: null,
        sortFn: (a: MonitoringSheetIndexDashboardDto, b: MonitoringSheetIndexDashboardDto) => sortNullableString(a.periodicity, b.periodicity),
        sortDirections: ['ascend', 'descend', null],
        listOfFilter: [
            // Initialized by call API
        ],
        // filterFn: (list: string[], item: DecisionPerimeter) => list.some(periodicity => item.frequency.periodicity.indexOf(periodicity) !== -1),
        filterFn: (list: string[], item: MonitoringSheetIndexDashboardDto) => list.some(periodicity => {
            if (periodicity === null) {
                return !item.periodicity || item.periodicity.trim() === '';
            }
            return item.periodicity && item.periodicity.toLowerCase() === periodicity.toLowerCase();
        }),
        filterMultiple: true,
        type: 'string',
        defaultFilter: true,
        searchFilter: false
    },
    {
        name: 'dashboard.table.endDate',
        value: DashboardMonitoringSheetColumnKeys.END_DATE,
        sortOrder: null,
        sortFn: (a: MonitoringSheetIndexDashboardDto, b: MonitoringSheetIndexDashboardDto) => sortDate(a.endDate, b.endDate),
        sortDirections: ['ascend', 'descend', null],
        listOfFilter: [],
        filterFn: (list: string[], item: MonitoringSheetIndexDashboardDto) => list.some(date => {
            if (date === null) {
                return !item.endDate; // null date
            }
            if (!item.endDate) return false;

            let dateUtc: Date;
            // get unique dates "YYYY-MM-DD"
            if (typeof item.endDate === 'string') {
                dateUtc = new Date(item.endDate + (date.includes('Z') ? '' : 'Z')); // Add z for utc format

            } else {
                dateUtc = item.endDate;
            }

            if (!(dateUtc instanceof Date) || isNaN(dateUtc.getTime())) {
                return false;
            }

            return dateUtc.toLocaleDateString() === date;
        }),
        filterMultiple: true,
        type: 'date',
        searchFilter: false
    },
    // {
    //     name: 'Actions',
    //     value: DashboardMonitoringSheetColumnKeys.ACTION,
    //     sortOrder: null,
    //     sortFn: null,
    //     sortDirections: ['ascend', 'descend', null],
    //     listOfFilter: [],
    //     filterFn: null,
    //     filterMultiple: false,
    //     type: 'string',
    //     searchFilter: false
    // }
];
